import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import { CountryStatusCssClasses } from "../CountriesUIHelpers";
import { useCountriesUIContext } from "../CountriesUIContext";

const selectedCountries = (entities, ids) => {
  const _countries = [];
  ids.forEach((id) => {
    const country = entities.find((el) => el.id === id);
    if (country) {
      _countries.push(country);
    }
  });
  return _countries;
};

export function CountriesFetchDialog({ show, onHide }) {
  // Countries UI Context
  const countriesUIContext = useCountriesUIContext();
  const countriesUIProps = useMemo(() => {
    return {
      ids: countriesUIContext.ids,
      queryParams: countriesUIContext.queryParams,
    };
  }, [countriesUIContext]);

  // Countries Redux state
  const { countries } = useSelector(
    (state) => ({
      countries: selectedCountries(state.countries.entities, countriesUIProps.ids),
    }),
    shallowEqual
  );

  // if there weren't selected ids we should close modal
  useEffect(() => {
    if (!countriesUIProps.ids || countriesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countriesUIProps.ids]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Fetch selected elements
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="list-timeline list-timeline-skin-light padding-30">
          <div className="list-timeline-items">
            {countries.map((country) => (
              <div className="list-timeline-item mb-3" key={country.id}>
                <span className="list-timeline-text">
                  <span
                    className={`label label-lg label-light-${
                      CountryStatusCssClasses[country.status]
                    } label-inline`}
                    
                  >
                    ID: {country.id}
                  </span>{" "}
                  <span className={`label label-lg label-light-${
                      CountryStatusCssClasses[country.status]
                    } label-inline`}>
                    name : {country.name}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-primary btn-elevate"
          >
            Ok
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
